import React, {Component} from 'react';
import {Modal, ModalHeader, ModalBody, Table} from 'reactstrap';

//style
import '../../../css/displaytestcase.css';
import {renderOSConf} from "./OSRenderHelpers";

class DisplayTestCase extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isOpen: props.showModal
        };

        this.toggleModal = this.toggleModal.bind(this);
    }

    componentWillReceiveProps(newProps) {
        this.setState({
            isOpen: newProps.showModal
        });
    }

    toggleModal() {
        if(this.state.isOpen) {
            //notify parent that modal is closed
            this.props.closeModalHandler();
        }
        else {
            this.setState({isOpen: !this.state.isOpen});
        }
    }

    render_args_field(field) {
        if(field !== null) {
            return (
                <tr>
                    <th> Pokretanje programa </th>
                    <td> <pre>./a.out {field}</pre> </td>
                </tr>
            );
        }
        else
            return null;
    }

    render_field(field, title) {
        if(field !== null) {
            return (
                <tr>
                    <th> {title} </th>
                    <td> <pre>{field}</pre> </td>
                </tr>
            );
        }
        else
            return null;
    }

    render_array_field(array_field, title) {
        if(array_field.length > 0) {
            var retHtml = array_field.map((item) => {
               return (
                   <tr>
                       <th> {title}<br/> {item.filename} </th>
                       <td> <pre>{item.content}</pre> </td>
                   </tr>
               )
            });
            return retHtml;
        }
        else
            return null;
    }

    render() {
        const testCase = this.props.testCase;
        if(testCase === null){
            return <div/>
        }
        const testCaseIO = testCase.testCaseIO;
        const testCaseOSConf = testCase.testCaseOSConf;
        let IOJSX;
        let OSConfJSX;
        if(testCaseIO === null)
        {
            IOJSX = <div/>;
        }
        else{
            IOJSX =
                <div className="row">
                    <Table bordered>
                        <tbody>
                        {this.render_args_field(testCaseIO.args)}
                        {this.render_field(testCaseIO.input, "Standardni ulaz")}
                        {this.render_array_field(testCaseIO.input_files, "Ulazni fajl:")}
                        {this.render_field(testCaseIO.output, "Standardni izlaz")}
                        {this.render_array_field(testCaseIO.output_files, "Izlazni fajl:")}
                        {this.render_field(testCaseIO.error, "Standardni izlaz za greške")}
                        {this.render_field(testCaseIO.exit_code, "Očekivani exit code")}
                        </tbody>
                    </Table>
                </div>
        }
        if(testCaseOSConf === null){
            OSConfJSX = <div/>
        }
        else{
            OSConfJSX =
                <div className={"row"}>
                    {renderOSConf(testCaseOSConf)}
                </div>
        }
        return (
            <Modal isOpen={this.state.isOpen} toggle={this.toggleModal} className="testCaseModal" centered={true}>
                <ModalHeader toggle={this.toggleModal}>
                    <h4>Pregled jednog od test primera koji ne prolazi</h4>
                </ModalHeader>
                <ModalBody className="testCaseModalBody" style={{overflow:"auto"}}>
                    {IOJSX}
                    {OSConfJSX}
                </ModalBody>
            </Modal>
        );
    }
}



export default DisplayTestCase;
